*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  --ch-drag-bar__size: 5px;
  display: grid;
  position: relative;
  block-size: 100%;
  inline-size: 100%;
}

:host(.gx-layout-splitter--resizing) ::slotted(*) {
  pointer-events: none;
}

.bar {
  --position-fix: calc((var(--size, 0px) - var(--ch-drag-bar__size)) / 2);
  position: relative;
  inline-size: 100%;
  block-size: 100%;
  background-color: currentColor;
  z-index: 1;
}
.bar[aria-disabled] {
  pointer-events: none;
}
.bar:focus-visible {
  outline: unset;
}
.bar::after {
  content: "";
  display: flex;
  position: absolute;
  background-color: currentColor;
  opacity: 0;
  transition: opacity 0s linear;
}
.bar:is(:active, :focus-visible, :hover)::after {
  opacity: 1;
}
.bar:hover::after {
  transition-delay: 250ms;
}

.leaf {
  display: contents;
}

.group {
  display: grid;
  position: relative;
}

.direction--columns {
  grid-template-columns: var(--ch-layout-splitter__distribution);
}
.direction--columns > .bar {
  cursor: ew-resize;
}
.direction--columns > .bar::after {
  block-size: 100%;
  inline-size: var(--ch-drag-bar__size);
  margin-inline-start: var(--position-fix);
}

.direction--rows {
  grid-template-rows: var(--ch-layout-splitter__distribution);
}
.direction--rows > .bar {
  cursor: ns-resize;
}
.direction--rows > .bar::after {
  block-size: var(--ch-drag-bar__size);
  inline-size: 100%;
  margin-block-start: var(--position-fix);
}